import React from 'react';

export class StepDescription extends React.Component{
    render() {
        return(
            <p className="animate__animated animate__fadeInUp stepDescription font-weight-bold py-3">
                {this.props.children}
            </p>
        );
    }
}